import StartupOperatorsSolutionHelper from "../../../Components/Operators/Solutions/Index";

const StartupOperatorsSolutionPage = () => {
  return <StartupOperatorsSolutionHelper />;
};

export default StartupOperatorsSolutionPage;
